import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import FormHelperText from '../FormHelperText';
import { createElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TypeCustomSelect = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
  startDataCollection,
  size,
  fallbackLabel,
}) => {
  const defaultValue = field.default !== undefined ? field.default : '';

  const [value, setValue] = useState(defaultValue);
  const { t } = useTranslation();
  function handleChange(e) {
    updateValidationOnChange(field.key, e.target.value);
    setValue(e.target.value);
  }

  useEffect(() => {
    if (!startDataCollection || Object.keys(startDataCollection).length == 0)
      return;
    const startValue = startDataCollection[field.key];
    setValue(startValue === undefined || startValue === null ? defaultValue : startValue);
  }, [startDataCollection]);

  useEffect(() => {
    const newValue = dataCollection[field.key];
    if (newValue !== undefined && newValue !== null) {
      setValue(newValue);
    }
  }, [dataCollection[field.key]]);

  return (
    <FormControl fullWidth size={size}>
      <InputLabel id="origin-simple-select-label">{field.label}</InputLabel>
      <Select
        labelId="origin-simple-select-label"
        id="origin-simple-select"
        value={value}
        label={field.label}
        onChange={handleChange}
        className="pr-7"
        disabled={field.disabled}
      >
        {!field.noUnselect && <MenuItem value="">{t('No Select')}</MenuItem>}
        {field.options &&
          field.options.map((option) => (
            <MenuItem key={option.label} value={option.value}>
              {option.Icon &&
                createElement(option.Icon, { sx: { marginRight: '5px' } })}
              {typeof option.label == 'string' ? t(option.label) : option.label}
            </MenuItem>
          ))}
        {fallbackLabel &&
          !field.options.some((option) => option.value == value) && (
            <MenuItem value={value} disabled>
              {fallbackLabel}
            </MenuItem>
          )}
      </Select>
      <FormHelperText />
    </FormControl>
  );
};

export default TypeCustomSelect;
